import useSettingsGlobals from '@/composables/useSettingsGlobals';

// Persistence of the Gorge Windbow's selected model id. Mirrors the legacy
// Windbow _getSavedSelectedModels / _saveSelectedModel: a single localStorage
// object ({ modelId }) on the web, and native messaging (android alert / iOS
// webkit) inside the app webview, where the initial value arrives via the
// `windbow_model_id` query param.
export const useWindbowModelStorage = (storageKey = 'WindbowSettings') => {
  const { $WEB_VIEW, $PLATFORM } = useSettingsGlobals();

  function readStore() {
    try {
      return JSON.parse(window.localStorage.getItem(storageKey)) || {};
    } catch {
      return {};
    }
  }

  // Normalize to a number so the selection compares cleanly against the API
  // model ids (legacy entries / query params may be strings).
  function toId(value) {
    if (value == null || value === '') return null;

    const id = Number(value);
    return Number.isNaN(id) ? null : id;
  }

  function read() {
    if ($WEB_VIEW) {
      return toId(new URLSearchParams(window.location.search).get('windbow_model_id'));
    }

    return toId(readStore().modelId);
  }

  function save(modelId) {
    const id = toId(modelId);
    if (id == null) return;

    if (!$WEB_VIEW) {
      const store = readStore();
      store.modelId = id;
      window.localStorage.setItem(storageKey, JSON.stringify(store));
      return;
    }

    if ($PLATFORM === 'android') {
      alert(`windbowModelChanged,${id}`);
      return;
    }

    try {
      window.webkit.messageHandlers.observe.postMessage({ modelId: id, type: 'windbow-model' });
    } catch (error) {
      console.warn('Error saving selected windbow model:', error);
    }
  }

  return { read, save };
};
